import {Component, EventEmitter, Inject, Input, OnInit, Output, OnDestroy, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TaxReturnService } from "../../../../../../swaggerServices";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "bulk-generate-package",
    templateUrl: "./bulk-generate-package.component.html",
    styleUrls: ["./bulk-generate-package.component.scss"],
    standalone: false
})
export class BulkGeneratePackage implements OnInit, OnDestroy {
  @Input() selectedTaxReturns;
  @Input() populationId;
  @Input() taxReturnAlias: string;
  @Output() completed = new EventEmitter();
  showModal = true;
  responseData = [];
  bulkActionState: "OPENED" | "LOADING" | "COMPLETED" = null;
  errorMessage = "";

  private unsubscribe: Subject<void> = new Subject();
  constructor(private taxReturnService: TaxReturnService,
    @Optional() private dialogRef?: MatDialogRef<BulkGeneratePackage>,
    @Optional() @Inject(MAT_DIALOG_DATA) data?: Partial<BulkGeneratePackage>) {
    Object.assign(this, data);
  }

  get selectedTaxReturnIds() {
    return this.selectedTaxReturns ?  Object.keys(this.selectedTaxReturns).map(n=>Number(n)) : [];
  }

  get submitButtonDisabled() {
    return !this.populationId || this.bulkActionState==='LOADING';
  }

  ngOnInit() {
      this.bulkActionState = 'OPENED';
      this.errorMessage = '';
      if (!this.populationId) {
        this.errorMessage = 'Population id is not provided';
        return;
      }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  bulkGenerate() {
    
    this.errorMessage = '';
    this.bulkActionState = 'LOADING';
      this.taxReturnService.bulkGeneratePackage({taxReturnIds:  this.selectedTaxReturnIds, populationId: parseInt(this.populationId)})
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(resp => {
        this.bulkActionState = 'COMPLETED';
      }, error => {
        this.errorMessage = "Something went wrong, please try again later.";
        this.bulkActionState = 'OPENED';
        return;
      });
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.showModal = false;
    this.completed.emit();
  }

}
